import React from "react";
const MobilePortraitPage = () => {
  return (
    <>
      <div
        className="container-fluid welcome-wrapper content-wrapper text-center"
        style={{ top: "50%" }}
      >
        <p className="mb-0 m-tagline">
          SITE VISIBLE UNIQUEMENT HORIZONTALEMENT SUR MOBILE, ORDINATEURS,
          TABLETTES
        </p>
      </div>
    </>
  );
};
export default MobilePortraitPage;
